import { onAllPreloadScriptsLoaded } from "../../../utils";
import { PasswordComponent } from "../../../fragments/password/password-component/password_component";
import { PasswordConfig } from "../../../fragments/password/password-component/password_config";
import { SimpleValidatedFieldComponent } from "../../../fragments/simpleValidatedField/simple-validated-field-component";
import { appendSpinnerToFormButtons } from "../../../spinner";
import { SalutationComponent } from "../../../fragments/salutation/salutation-component";
import { EmailComponent } from "../../../fragments/email/email-component"
import './page.scss'
import { FormStorage } from "../../../session/form-storage"

export const accountPage = async (documentObject: Document) => {
    const validateImmediatelyElement: HTMLInputElement = documentObject.querySelector(`[data-validateImmediately]`)!!;
    const validateImmediately = validateImmediatelyElement.getAttribute("data-validateImmediately") === "true";

    appendSpinnerToFormButtons(documentObject, `[data-qa="fti-registration-create-account-form"]`);

    const salutationComponent = new SalutationComponent(documentObject, validateImmediately);

    const firstnameComponent = new SimpleValidatedFieldComponent(documentObject, "firstName", validateImmediately, "firstName");

    const lastnameComponent = new SimpleValidatedFieldComponent(documentObject, "lastName", validateImmediately, "lastName");

    const hasEmailRepetition = documentObject.querySelector(`[data-qa="fti-registration-emailRepeat-input"]`) != null
    const emailComponent = hasEmailRepetition ? new EmailComponent(documentObject, validateImmediately) : new SimpleValidatedFieldComponent(documentObject, "email", validateImmediately, "email")

    const blockListElementConfig = new PasswordConfig();
    blockListElementConfig.blockListInputSelectors.set("email", '[data-qa="fti-registration-email-input"]');
    blockListElementConfig.blockListInputSelectors.set("firstname", '[data-qa="fti-registration-firstName-input"]');
    blockListElementConfig.blockListInputSelectors.set("lastname", '[data-qa="fti-registration-lastName-input"]');
    new PasswordComponent(documentObject, blockListElementConfig, validateImmediately);
    const formStorage = new FormStorage(documentObject, "fti-cr-account-form")
    await formStorage.setFormValues()

    /*                                                                                      */
    if (validateImmediately) {
        firstnameComponent.validate();
        lastnameComponent.validate();
        emailComponent.validate();
        salutationComponent.updateStatus();
    }
};
onAllPreloadScriptsLoaded(async () => await accountPage(document));
